<script>
import UserInfoComponent from '@/components/UserInfoComponent'
import RightLayout from '../layouts/rightLayout'
import { formatDate } from '@/utils/date.js'
export default {
  components: {UserInfoComponent, RightLayout},
  data () {
    return {
      // ユーザープロフィール情報
      userProfileModel: {
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        sex: 0,
        birthday: '',
        homeAddress: '',
        homeLat: '',
        homeLng: '',
        homeTelephone: '',
        portableTelephone: null,
        postalcode: '',
        fax: null,
        passengerCost: null,
        note: null
      },
      // ドライバープロフィール情報
      userDriverProfileModel: {
        facePhotoUrl: null,
        driverLicenseDeadline: '',
        joinDate: formatDate(new Date(), 'yyyyMMdd'),
        accidentFlag: null,
        accidentDetails: null,
        sanctionFlag: null,
        sanctionDetails: null,
        rewardFlag: null,
        driverLicensePhotoUrl1: null,
        driverLicensePhotoUrl2: null
      },
      // 交通事業者プロフィール情報
      userTransportDriverProfileModel: {
        // uid: '',
        transportId: null,
      },
      // ユーザーアカウント情報
      userAccountModel: {
        roleFlag: '00000',
        joinDate: formatDate(new Date(), 'yyyyMMdd')
      },
    }
  }
}
</script>

<template>
<right-layout>
<user-info-component
    :title="'アカウントを登録'"
    :btnName="'登録'"
    :userProfileModel=userProfileModel
    :userDriverProfileModel=userDriverProfileModel
    :userTransportDriverProfileModel=userTransportDriverProfileModel
    :userAccountModel=userAccountModel
    ></user-info-component>
</right-layout>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/views/UserLogin.vue